import React from 'react';

import {
  useThemeGetter,
  useThemeSwitcher,
  useChangeActiveSectionOnScroll,
} from '@hooks';

import { WoodBackground } from '@components/WoodBackground';
import { TopNavBar } from './TopNavBar';

import {
  ContentContainer,
  NavMenuContainer,
  BackgroundContainer,
} from './NavMenu.styled';

import { NavMenuProps } from './NavMenu.types';

export const NavMenu = ({ children }: NavMenuProps) => {
  const { container, scrollToSection } = useChangeActiveSectionOnScroll();
  const themeSwitcher = useThemeSwitcher();
  const { theme } = useThemeGetter();

  return (
    <NavMenuContainer background={theme.Background}>
      <BackgroundContainer>
        <WoodBackground />
        <TopNavBar
          scrollToSection={scrollToSection}
          themeSwitcher={themeSwitcher}
        />
      </BackgroundContainer>

      <ContentContainer
        ref={container}
        secondary={theme.Secondary}
        highlight={theme.Highlight}
      >
        {children}
      </ContentContainer>
    </NavMenuContainer>
  );
};
